export const otherCode= {
  404:"404 NOT FOUND",
  1001: "用户名或密码错误!",
  1002: '手机号码格式错误!',
  1003: '手机号码已存在!',
  1199: '手机号码不存在!',
  1004: '该id不存在!',
  1005: '参数异常!',
  1006: '文件上传失败!',
  403: '没有访问权限',
  1007: '账号格式错误',
  1008: '数组长度不正确',
  1009: '密码错误',
  1010: '样本文件与分组文件不匹配',
  1011: '请先上传分组文件',
  1012: '姓名与手机号码不匹配',
  1013: '姓名对应多个用户',
  1014: '该手机号码在其他角色中已存在!',
  1015: '客户名称与手机号码不匹配',
  1016: '文件格式错误!',
  1017: '该姓名对应多个用户，请使用id继续',
  5500: '绘制失败',
  5856: '当前模块执行失败',
  4404: '当前数据文件不存在',
  7707: '分析数目达到上限',
  9853: '验证码错误',
  9345: '输入验证码错误',
  4869: '样本不存在',
  4868: '分组已存在',
  4870: '原始数据未确认',
  5913: '问卷未知错误',
  5934: '邮件',

}
